export enum UPDATE_PAGINATION {
  INCREMENT,
  DECREMENT,
}
